import React from "react";
import { Statuses, Keys } from "../constant/status";
import { ActionButton } from "../component/ActionButton";
import FreeOrderProgress1 from "../assets/svg/FreeOrderProgress1";
import FreeOrderProgress2 from "../assets/svg/FreeOrderProgress2";
import FreeOrderProgress3 from "../assets/svg/FreeOrderProgress3";
import FreeOrderProgress4 from "../assets/svg/FreeOrderProgress4";
import ReplacementOrderProgress1 from "../assets/svg/ReplacementOrderProgress1";
import ReplacementOrderProgress2 from "../assets/svg/ReplacementOrderProgress2";
import ReplacementOrderProgress3 from "../assets/svg/ReplacementOrderProgress3";
import ReplacementOrderProgress4 from "../assets/svg/ReplacementOrderProgress4";

const OrderProgressSvg = ({ status, isFreeDrug }) => {
  return (
    <>
      {status === Statuses[Keys.order_required].key &&
        (isFreeDrug ? <FreeOrderProgress1 /> : <ReplacementOrderProgress2 />)}

      {status === Statuses[Keys.in_transit].key &&
        (isFreeDrug ? <FreeOrderProgress2 /> : <ReplacementOrderProgress3 />)}

      {(status === Statuses[Keys.in_pharmacy].key || status === Statuses[Keys.in_pharmacy_free].key) &&
        (isFreeDrug ? <FreeOrderProgress3 /> : <ReplacementOrderProgress4 />)}

      {(status === Statuses[Keys.drug_dispensed].key || status === Statuses[Keys.drug_dispensed_free].key) &&
        (isFreeDrug ? <FreeOrderProgress4 /> : <ReplacementOrderProgress1 />)}
    </>
  );
};

const PatientOrderProgress = ({ patient, id, order }) => {
  const { status, isFreeDrug } = order;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        backgroundColor: "#F9FBFF",
        padding: 16
      }}
      data-tm-id="cct-cycles-info-graph"
    >
      <OrderProgressSvg status={status} isFreeDrug={isFreeDrug} />
      <ActionButton showOverdue={false} patient={patient} order={order} actionButtonId={id} />
    </div>
  );
};

export { PatientOrderProgress };
